import React from "react";
import EventMain from "./components/EventMain";

import "./styles.scss";

function App() {
  return (
    <div className="app">
      <EventMain />
    </div>
  );
}

export default App;
